import React, { useState, useEffect } from "react";
import { Button, Form, Col, Row } from "react-bootstrap";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../../../_metronic/_partials/controls";
import { useSelector, useDispatch } from "react-redux";
import {
  selectSelected,
  createApproval,
  createInvoice,
  setKeepData,
  selectKeepData,
  fetchReturnId,
  selectReturnId,
} from "./reportHeaderSlice";
import { useHistory, useParams } from "react-router-dom";
import {
  formatDateTime,
  showSuccessDialog,
  showErrorDialog,
  formatDate,
  formatDateTimeUtc,
  isAfterOrEqual,
} from "../../../utility";
import LoadingFetchData from "../../new-return/without-rtv/LoadingFetchData";
import { fetchFareye, updatePrint } from "../../chief-delivery/deliverySlice";
import { selectSettingId } from "../../administrator/general-setting/generalSettingSlice";

export const ReportHeaderDetail = (data) => {
  const history = useHistory();
  const dataId = useSelector(selectReturnId);
  const dispatch = useDispatch();
  const { id } = useParams();

  const keepData = useSelector(selectKeepData);
  const [overlay, setOverlay] = useState(false);
  const [validasi, setValidasi] = useState(null);
  const [items, setItems] = useState(null);
  const dataSettingId = useSelector(selectSettingId);

  const cutoff = dataSettingId?.plants || [];

  useEffect(() => {
    async function fetchMyAPI() {
      // Fetch data on first load
      await callApiId(id);
    }
    fetchMyAPI();
  }, [dispatch]);

  const callApiId = async (id) => {
    setOverlay(true);
    try {
      const response = await dispatch(fetchReturnId(id));
      if (response.payload.status === 200) {
        setOverlay(false);
      } else {
        setOverlay(false);
        showErrorDialog(response.payload.data.message);
      }
    } catch (error) {
      setOverlay(false);

      // showErrorDialog("Something went wrong!");
    }
  };

  useEffect(() => {
    if (dataId !== null) {
      var approvalStatus = dataId.items.filter(function(items) {
        return items.approvalStatus === "R";
      });

      const check =
        dataId.items.length === approvalStatus.length ? true : false;

      setValidasi(check);

      setItems(dataId.approvalMaterial[0]);
    }
  }, [dataId]);

  const fareyeFormatter = (row) => {
    let label = "";

    const plantCutoff = cutoff.find(
      (plant) => plant.plantCode === row.plant_code
    );
    const cutoffDate = plantCutoff?.cutOffDate || "";

    if (row.fareye_last_error === "not go live") {
      label = "Irrelevant - Plant";
    } else if (
      !row.fareye_status &&
      dataId?.firstPrintDate === "0001-01-01T00:00:00Z"
    ) {
      label = "Not Send";
    } else if (!row.fareye_status && !!row.fareye_last_error) {
      label = "Error";
    } else if (
      !row.fareye_status &&
      dataId?.firstPrintDate !== "0001-01-01T00:00:00Z"
    ) {
      label = "Waiting";
    } else if (!!row.fareye_status) {
      label = row.fareye_status;
    } else {
      label = row.fareye_status;
    }

    if (
      !row.fareye_status &&
      dataId?.firstPrintDate !== "0001-01-01T00:00:00Z" &&
      !row.fareye_last_error
    ) {
      if (!cutoffDate) {
        label = "Irrelevant - Cut Off";
      } else {
        label = isAfterOrEqual(dataId?.firstPrintDate, cutoffDate)
          ? "Waiting"
          : "Irrelevant - Cut Off";
      }
    }

    return label; // <- sekarang string
  };

  const handlePost = async () => {
    setOverlay(true);
    const retNumber = dataId.retNumber;
    const params = {
      status: "A",
    };
    try {
      const response = await dispatch(createApproval({ params, retNumber }));
      if (response.payload.status === 200) {
        showSuccessDialog(
          "Data has been saved!",
          `Return have been Saved, your Sales Order number : <strong>${response.payload.data.data}</strong>`
        );
        history.push("/report-return/report-header");
      } else {
        setOverlay(false);
        showErrorDialog(response.payload.message);
      }
    } catch (error) {
      setOverlay(false);
      console.log(error.message);
    }
  };

  const handleFareye = async () => {
    setOverlay(true);

    try {
      const response = await dispatch(fetchFareye(dataId.retNumber));
      console.log(response, "response");
      setOverlay(false);

      if (response.payload.status === 200) {
        showSuccessDialog(response.payload.data);
        await callApiId(id);
        // history.push("/report-return/report-header");
      } else {
        showErrorDialog(response.payload.message);
      }
    } catch (error) {
      setOverlay(false);
      console.log(error.message);
    }
  };

  const handlePostInvoice = async () => {
    setOverlay(true);

    const retNumber = dataId.retNumber;
    const params = {
      status: "A",
    };
    try {
      const response = await dispatch(createInvoice(retNumber));
      if (response.payload.status === 200) {
        showSuccessDialog(
          "Data has been saved!",
          `Return have been Saved, your Invoice return number : <strong>${response.payload.data}</strong>`
        );
        history.push("/report-return/report-header");
      } else {
        setOverlay(false);
        showErrorDialog(response.payload.message);
      }
    } catch (error) {
      setOverlay(false);

      console.log(error);
      showErrorDialog("eror something wrong");
    }
  };

  return overlay ? (
    <LoadingFetchData active={overlay} />
  ) : (
    <>
      {dataId && items && (
        <Card>
          <LoadingFetchData active={overlay} />

          <CardHeader title="Report Return Header">
            <CardHeaderToolbar>
              <button
                type="button"
                className="btn btn-primary"
                onClick={() =>
                  history.push(
                    `/report-return/report-detail/${items.ret_number}`
                  )
                }
              >
                Detail
              </button>
            </CardHeaderToolbar>
          </CardHeader>

          <CardBody>
            <Form>
              <Form.Group as={Row}>
                <Col sm={6}>
                  <Form.Group as={Row}>
                    <Form.Label column sm={3}>
                      <b>APL Return Number </b>
                    </Form.Label>
                    <Col sm={8}>
                      <Form.Control disabled value={items.ret_number} />
                    </Col>
                  </Form.Group>

                  <Form.Group as={Row}>
                    <Form.Label column sm={3}>
                      <b>RTV Number</b>
                    </Form.Label>
                    <Col sm={8}>
                      <Form.Control disabled value={items.rtv_no} />
                    </Col>
                  </Form.Group>
                  <Form.Group as={Row}>
                    <Form.Label column sm={3}>
                      <b>RTV Date</b>
                    </Form.Label>
                    <Col sm={8}>
                      <Form.Control
                        disabled
                        value={formatDate(items.rtv_date)}
                      />
                    </Col>
                  </Form.Group>
                  <Form.Group as={Row}>
                    <Form.Label column sm={3}>
                      <b>RTV Receiving Date</b>
                    </Form.Label>
                    <Col sm={8}>
                      <Form.Control
                        disabled
                        value={formatDate(items.rtv_receiving_date)}
                      />
                    </Col>
                  </Form.Group>
                  <Form.Group as={Row}>
                    <Form.Label column sm={3}>
                      <b>Remarks Rtv</b>
                    </Form.Label>
                    <Col sm={8}>
                      <Form.Control
                        as="textarea"
                        style={{ height: "70px" }}
                        disabled
                        value={items.remarks_rtv}
                      />
                    </Col>
                  </Form.Group>
                  <Form.Group as={Row}>
                    <Form.Label column sm={3}>
                      <b>Po Number</b>
                    </Form.Label>
                    <Col sm={8}>
                      <Form.Control disabled value={items.po_number} />
                    </Col>
                  </Form.Group>
                  <Form.Group as={Row}>
                    <Form.Label column sm={3}>
                      <b>Customer PO Date</b>
                    </Form.Label>
                    <Col sm={8}>
                      <Form.Control
                        disabled
                        value={formatDate(items.customer_podate)}
                      />
                    </Col>
                  </Form.Group>

                  <Form.Group as={Row}>
                    <Form.Label column sm={3}>
                      <b>Invoice Ref Number</b>
                    </Form.Label>
                    <Col sm={8}>
                      <Form.Control disabled value={items.invoice_ref_no} />
                    </Col>
                  </Form.Group>
                  <Form.Group as={Row}>
                    <Form.Label column sm={3}>
                      <b>Customer Code</b>
                    </Form.Label>
                    <Col sm={8}>
                      <Form.Control disabled value={items.customer_code} />
                    </Col>
                  </Form.Group>
                  <Form.Group as={Row}>
                    <Form.Label column sm={3}>
                      <b>Customer Name</b>
                    </Form.Label>
                    <Col sm={8}>
                      <Form.Control disabled value={items.customer_name} />
                    </Col>
                  </Form.Group>
                  <Form.Group as={Row}>
                    <Form.Label column sm={3}>
                      <b>Customer Group 3</b>
                    </Form.Label>
                    <Col sm={8}>
                      <Form.Control disabled value={items.customer_group3} />
                    </Col>
                  </Form.Group>
                  <Form.Group as={Row}>
                    <Form.Label column sm={3}>
                      <b>Address</b>
                    </Form.Label>
                    <Col sm={8}>
                      <Form.Control disabled value={items.address} />
                    </Col>
                  </Form.Group>
                  <Form.Group as={Row}>
                    <Form.Label column sm={3}>
                      <b>Remarks Return</b>
                    </Form.Label>
                    <Col sm={8}>
                      <Form.Control
                        as="textarea"
                        style={{ height: "70px" }}
                        disabled
                        value={items.remarks_return}
                      />
                    </Col>
                  </Form.Group>
                  <Form.Group as={Row}>
                    <Form.Label column sm={3}>
                      <b>Status</b>
                    </Form.Label>
                    <Col sm={8}>
                      <Form.Control disabled value={items.status} />
                    </Col>
                  </Form.Group>
                  <Form.Group as={Row}>
                    <Form.Label column sm={3}>
                      <b>Pending Process</b>
                    </Form.Label>
                    <Col sm={8}>
                      <Form.Control disabled value={items.pending_proses} />
                    </Col>
                  </Form.Group>
                  <Form.Group as={Row}>
                    <Form.Label column sm={3}>
                      <b>Pending Username </b>
                    </Form.Label>
                    <Col sm={8}>
                      <Form.Control
                        as="textarea"
                        style={{ height: "70px" }}
                        disabled
                        value={items.pending_user}
                      />
                    </Col>
                  </Form.Group>
                  <Form.Group as={Row}>
                    <Form.Label column sm={3}>
                      <b>Last Approved By</b>
                    </Form.Label>
                    <Col sm={8}>
                      <Form.Control disabled value={dataId.lastApprovalUser} />
                    </Col>
                  </Form.Group>
                  <Form.Group as={Row}>
                    <Form.Label column sm={3}>
                      <b>Last Approved Date Time</b>
                    </Form.Label>
                    <Col sm={8}>
                      <Form.Control
                        disabled
                        value={formatDateTime(dataId.lastApprovalDate)}
                      />
                    </Col>
                  </Form.Group>
                  <Form.Group as={Row}>
                    <Form.Label column sm={3}>
                      <b>SAP Response Date Time</b>
                    </Form.Label>
                    <Col sm={8}>
                      <Form.Control
                        disabled
                        value={formatDateTimeUtc(items.soCreateDate)}
                      />
                    </Col>
                  </Form.Group>
                  <Form.Group as={Row}>
                    <Form.Label column sm={3}>
                      <b>SAP Sales Order</b>
                    </Form.Label>
                    <Col sm={8}>
                      <Form.Control disabled value={items.soNo} />
                    </Col>
                  </Form.Group>
                  <Form.Group as={Row}>
                    <Form.Label column sm={3}>
                      <b>SAP Inv Return</b>
                    </Form.Label>
                    <Col sm={8}>
                      <Form.Control disabled value={items.invoiceReturnNo} />
                    </Col>
                  </Form.Group>
                  {items.soNo !== "" && items.invoiceReturnNo === "" && (
                    <Form.Group as={Row}>
                      <Form.Label column sm={3}>
                        <b>Get Inv Return</b>
                      </Form.Label>
                      <Col sm={8}>
                        <Button onClick={handlePostInvoice}>Get Invoice</Button>
                      </Col>
                    </Form.Group>
                  )}
                </Col>
                {/* Row kiri */}
                <Col sm={6}>
                  {/* <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>BRQA Approval Date time</b>
                  </Form.Label>
                  <Col sm={8}>
                    <Form.Control
                      disabled
                      value={formatDateTime(items.brqa_approval_datetime)}
                    />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>BRQA Approval Name</b>
                  </Form.Label>
                  <Col sm={8}>
                    <Form.Control disabled value={items.brqa_approval_user} />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>QA HO Approval Date Time</b>
                  </Form.Label>
                  <Col sm={8}>
                    <Form.Control
                      disabled
                      value={formatDateTime(items.qaho_approval_datetime)}
                    />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>QA HO Approval Name</b>
                  </Form.Label>
                  <Col sm={8}>
                    <Form.Control disabled value={items.qaho_approval_user} />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>QA Client Approval Date Time</b>
                  </Form.Label>
                  <Col sm={8}>
                    <Form.Control
                      disabled
                      value={formatDateTime(items.qaclient_approval_datetime)}
                    />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>QA Client Approval Name</b>
                  </Form.Label>
                  <Col sm={8}>
                    <Form.Control
                      disabled
                      value={items.qaclient_approval_user}
                    />
                  </Col>
                </Form.Group> */}
                  <Form.Group as={Row}>
                    <Form.Label column sm={3}>
                      <b>Sales Office</b>
                    </Form.Label>
                    <Col sm={8}>
                      <Form.Control disabled value={items.sales_office} />
                    </Col>
                  </Form.Group>
                  <Form.Group as={Row}>
                    <Form.Label column sm={3}>
                      <b>Plant Code</b>
                    </Form.Label>
                    <Col sm={8}>
                      <Form.Control disabled value={items.plant_code} />
                    </Col>
                  </Form.Group>
                  <Form.Group as={Row}>
                    <Form.Label column sm={3}>
                      <b>Plant Name</b>
                    </Form.Label>
                    <Col sm={8}>
                      <Form.Control disabled value={items.plant_name} />
                    </Col>
                  </Form.Group>
                  <Form.Group as={Row}>
                    <Form.Label column sm={3}>
                      <b>Reason Name</b>
                    </Form.Label>
                    <Col sm={8}>
                      <Form.Control disabled value={items.reason_name} />
                    </Col>
                  </Form.Group>
                  <Form.Group as={Row}>
                    <Form.Label column sm={3}>
                      <b>User Create</b>
                    </Form.Label>
                    <Col sm={8}>
                      <Form.Control disabled value={items.created_username} />
                    </Col>
                  </Form.Group>
                  <Form.Group as={Row}>
                    <Form.Label column sm={3}>
                      <b>Reporter</b>
                    </Form.Label>
                    <Col sm={8}>
                      <Form.Control disabled value={items.reporter} />
                    </Col>
                  </Form.Group>
                  <Form.Group as={Row}>
                    <Form.Label column sm={3}>
                      <b>Create Date Time</b>
                    </Form.Label>
                    <Col sm={8}>
                      <Form.Control
                        disabled
                        value={formatDateTime(items.created_date)}
                      />
                    </Col>
                  </Form.Group>
                  <Form.Group as={Row}>
                    <Form.Label column sm={3}>
                      <b>First Print Name</b>
                    </Form.Label>
                    <Col sm={8}>
                      <Form.Control disabled value={dataId.firstPrintName} />
                    </Col>
                  </Form.Group>
                  <Form.Group as={Row}>
                    <Form.Label column sm={3}>
                      <b>First Print Date</b>
                    </Form.Label>
                    <Col sm={8}>
                      <Form.Control
                        disabled
                        value={formatDateTime(dataId.firstPrintDate)}
                      />
                    </Col>
                  </Form.Group>
                  {/* {items?.fareye_status === "" &&
                    items?.step_code === "CD" &&
                    items?.fareye_last_error !== "" &&
                    items?.fareye_last_error !== "not go live" && (
                      <Form.Group as={Row}>
                        <Form.Label column sm={3}>
                          <b>Retry Post Fareye</b>
                        </Form.Label>
                        <Col sm={8}>
                          <Button onClick={() => handleFareye()}>POST</Button>
                        </Col>
                      </Form.Group>
                    )} */}

                  {items?.fareye_status === "Error" && (
                    <Form.Group as={Row}>
                      <Form.Label column sm={3}>
                        <b>Retry Post Fareye</b>
                      </Form.Label>
                      <Col sm={8}>
                        <Button onClick={() => handleFareye()}>POST</Button>
                      </Col>
                    </Form.Group>
                  )}

                  {dataId.fareye_last_error !== "" && (
                    <Form.Group as={Row}>
                      <Form.Label column sm={3}>
                        <b>Fareye Last Error</b>
                      </Form.Label>
                      <Col sm={8}>
                        <Form.Control
                          disabled
                          as="textarea"
                          style={{ height: "100px" }}
                          value={
                            items.fareye_last_error === "not go live"
                              ? ""
                              : items.fareye_last_error
                          }
                        />
                      </Col>
                    </Form.Group>
                  )}

                  <Form.Group as={Row}>
                    <Form.Label column sm={3}>
                      <b>Last Print Name</b>
                    </Form.Label>
                    <Col sm={8}>
                      <Form.Control disabled value={dataId.lastPrintName} />
                    </Col>
                  </Form.Group>
                  <Form.Group as={Row}>
                    <Form.Label column sm={3}>
                      <b>Last Printed Date Time</b>
                    </Form.Label>
                    <Col sm={8}>
                      <Form.Control
                        disabled
                        value={formatDateTime(items.last_printed_datetime)}
                      />
                    </Col>
                  </Form.Group>

                  <Form.Group as={Row}>
                    <Form.Label column sm={3}>
                      <b>FPRE Uploaded Date</b>
                    </Form.Label>
                    <Col sm={8}>
                      <Form.Control
                        disabled
                        value={formatDateTime(items.fpre_upload_time)}
                      />
                    </Col>
                  </Form.Group>
                  {items.fpre_attachment_id !== "" && (
                    <Form.Group as={Row}>
                      <Form.Label column sm={3}>
                        <b>Download FPRE</b>
                      </Form.Label>
                      <Col sm={8}>
                        <Button
                          variant="secondary"
                          className="mr-3"
                          active
                          onClick={() => {
                            const url = `${process.env.REACT_APP_API_URL}/return/${items.ret_number}/fpre`;
                            window.open(url, "_blank").focus();
                          }}
                        >
                          <span className={`color-blue cursor-pointer`}>
                            FPRE - {items.ret_number}
                          </span>
                        </Button>
                      </Col>
                    </Form.Group>
                  )}
                  <Form.Group as={Row}>
                    <Form.Label column sm={3}>
                      <b>Fareye Status</b>
                    </Form.Label>
                    <Col sm={8}>
                      {/* Render formatter langsung */}
                      <Form.Control disabled value={fareyeFormatter(items)} />
                    </Col>
                  </Form.Group>

                  <Form.Group as={Row}>
                    <Form.Label column sm={3}>
                      <b>Fareye Date Time</b>
                    </Form.Label>
                    <Col sm={8}>
                      <Form.Control
                        disabled
                        value={formatDateTimeUtc(items.fareye_date)}
                      />
                    </Col>
                  </Form.Group>
                  <Form.Group as={Row}>
                    <Form.Label column sm={3}>
                      <b>Chief Delivery</b>
                    </Form.Label>
                    <Col sm={8}>
                      <Form.Control disabled value={items.cd_approval_user} />
                    </Col>
                  </Form.Group>
                  <Form.Group as={Row}>
                    <Form.Label column sm={3}>
                      <b>Chief Delivery Remarks</b>
                    </Form.Label>
                    <Col sm={8}>
                      <Form.Control disabled value={items.hdover_remarks} />
                    </Col>
                  </Form.Group>
                  <Form.Group as={Row}>
                    <Form.Label column sm={3}>
                      <b>Warehouse Receive Date Time</b>
                    </Form.Label>
                    <Col sm={8}>
                      <Form.Control
                        disabled
                        value={formatDateTimeUtc(items.cw_approval_datetime)}
                      />
                    </Col>
                  </Form.Group>
                  <Form.Group as={Row}>
                    <Form.Label column sm={3}>
                      <b>Chief Warehouse</b>
                    </Form.Label>
                    <Col sm={8}>
                      <Form.Control disabled value={items.cw_approval_user} />
                    </Col>
                  </Form.Group>

                  <Form.Group as={Row}>
                    <Form.Label column sm={3}>
                      <b>Chief Warehouse Remarks</b>
                    </Form.Label>
                    <Col sm={8}>
                      <Form.Control disabled value={items.cw_remarks} />
                    </Col>
                  </Form.Group>
                  <Form.Group as={Row}>
                    <Form.Label column sm={3}>
                      <b>Lead Time (Day)</b>
                    </Form.Label>
                    <Col sm={8}>
                      <Form.Control disabled value={items.lead_time} />
                    </Col>
                  </Form.Group>

                  <Form.Group as={Row}>
                    <Form.Label column sm={3}>
                      <b>SAP Response Status</b>
                    </Form.Label>
                    <Col sm={8}>
                      <Form.Control disabled value={items.soStatus} />
                    </Col>
                  </Form.Group>
                  <Form.Group as={Row}>
                    <Form.Label column sm={3}>
                      <b>SAP Response Error</b>
                    </Form.Label>
                    <Col sm={8}>
                      <Form.Control
                        as="textarea"
                        style={{ height: "100px" }}
                        disabled
                        value={items.soLastError}
                      />
                    </Col>
                  </Form.Group>
                  <Form.Group as={Row}>
                    <Form.Label column sm={3}>
                      <b>Remark Reject Sales</b>
                    </Form.Label>
                    <Col sm={8}>
                      <Form.Control
                        as="textarea"
                        style={{ height: "100px" }}
                        disabled
                        value={items.remarkRejectSales}
                      />
                    </Col>
                  </Form.Group>
                  {items.soStatus === "FAILED" && items.step_code === "END" && (
                    <Form.Group as={Row}>
                      <Form.Label column sm={3}>
                        <b>Retry Send To SAP</b>
                      </Form.Label>
                      <Col sm={8}>
                        <Button onClick={handlePost}>POST</Button>
                      </Col>
                    </Form.Group>
                  )}
                  {items.soStatus === "" &&
                    items.step_code === "END" &&
                    validasi === false && (
                      <Form.Group as={Row}>
                        <Form.Label column sm={3}>
                          <b>Retry Send To SAP</b>
                        </Form.Label>
                        <Col sm={8}>
                          <Button onClick={handlePost}>POST</Button>
                        </Col>
                      </Form.Group>
                    )}
                </Col>
              </Form.Group>
            </Form>
            <Row className="mt-6">
              <Button
                variant="light"
                className="mr-3"
                onClick={() => {
                  history.push(
                    `/report-return/report-header/${items.ret_number}`
                  );
                }}
              >
                <i className="fa fa-arrow-left"></i>Back
              </Button>
            </Row>
          </CardBody>
        </Card>
      )}
    </>
  );
};
